import { render, staticRenderFns } from "./WarehouseTabOffersInvoices.vue?vue&type=template&id=50c07e64&scoped=true"
import script from "./WarehouseTabOffersInvoices.vue?vue&type=script&lang=js"
export * from "./WarehouseTabOffersInvoices.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTabOffersInvoices.vue?vue&type=style&index=0&id=50c07e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c07e64",
  null
  
)

export default component.exports